import axios from 'axios'

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
        'Content-Type': 'application/json'
    }
})
 
const formatAuthorization = idToken => idToken + '.' + btoa(JSON.stringify({ 'id': process.env.REACT_APP_ID }))

export default {  
    getServiceStock: (idToken) => new Promise((resolve, reject) => {
        console.log(process.env.REACT_APP_API_URL)
        instance.post(
            '/service/stock',
            {},
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
         .catch(error => {
            reject(error)
        })
    }),

    getServiceDetails: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            '/service/stock-details',
            {data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
        .catch(error => {
            reject(error)
        })
    })
}